module.exports = __webpack_public_path__ + "static/media/arrow-right-black.e6163875.svg";